"use strict";
/**
 * Datadog Browser RUM SDK - Full version with Session Replay and Real User Profiling capabilities.
 * Use this package to monitor your web application's performance and user experience.
 *
 * @packageDocumentation
 * @see [RUM Browser Monitoring Setup](https://docs.datadoghq.com/real_user_monitoring/browser/)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.datadogRum = exports.DefaultPrivacyLevel = void 0;
// Keep the following in sync with packages/rum-slim/src/entries/main.ts
const browser_core_1 = require("@datadog/browser-core");
const browser_rum_core_1 = require("@datadog/browser-rum-core");
const recorderApi_1 = require("../boot/recorderApi");
const deflate_1 = require("../domain/deflate");
const lazyLoadRecorder_1 = require("../boot/lazyLoadRecorder");
const profilerApi_1 = require("../boot/profilerApi");
var browser_core_2 = require("@datadog/browser-core");
Object.defineProperty(exports, "DefaultPrivacyLevel", { enumerable: true, get: function () { return browser_core_2.DefaultPrivacyLevel; } });
const recorderApi = (0, recorderApi_1.makeRecorderApi)(lazyLoadRecorder_1.lazyLoadRecorder);
const profilerApi = (0, profilerApi_1.makeProfilerApi)();
/**
 * The global RUM instance. Use this to call RUM methods.
 *
 * @see [RUM Browser Monitoring Setup](https://docs.datadoghq.com/real_user_monitoring/browser/)
 */
exports.datadogRum = (0, browser_rum_core_1.makeRumPublicApi)(browser_rum_core_1.startRum, recorderApi, profilerApi, {
    startDeflateWorker: deflate_1.startDeflateWorker,
    createDeflateEncoder: deflate_1.createDeflateEncoder,
    sdkName: 'rum',
});
(0, browser_core_1.defineGlobal)((0, browser_core_1.getGlobalObject)(), 'DD_RUM', exports.datadogRum);
//# sourceMappingURL=main.js.map